export const RTE_TOOLBAR_BLOCKS = {
  ORDERED_LIST: 'ordered-list',
  UNORDERED_LIST: 'unordered-list',
  QUOTE: 'blockquote',
};
